<template>
  <div class="container-fluid">
    <loading v-if="loadingRender"></loading>
    <panel Title="صدور سفته" Des="برای صدور سفته اطلاعات لازم را وارد کنید و از صحت اطلااعات اطمینان حاصل فرمایید." :IsBtnBack="false" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row">
      <ul>
        <li class="text-danger" v-for="(error, index) in ErrorList" :key="index">
          {{ error.message }}
        </li>
      </ul>
    </div>
    <div class="row">
      <div class="col-12">
        <h6>مشخصات سفته</h6>
      </div>
      <div class="col-md-3 col-12">
        <small>مبلغ سفته {{ $cookies.get('VahedPool') }}</small>
        <input type="text" @keypress="$ValidNumber($event, 16)" @keyup="$PutCommatoInput()" v-model="DataAxios.amount" dir="ltr" class="form-control 3ragham" />
        <span class="mt-4"> {{ Mab2persian() }} </span>
      </div>
      <div class="col-md-6 col-12">
        <small>شرح سفته</small>
        <input type="text" v-model="DataAxios.description" class="form-control" />
      </div>
      <div class="col-md-3 col-12">
        <small>تاریخ صدور</small>
        <!-- <input type="text" v-model="DataAxios.due_date" dir="ltr" class="form-control" /> -->
        <date-picker :editable="true" :auto-submit="true" color="rgb(94 163 30)" v-model="DataAxios.due_date"> </date-picker>
        <input type="text" tabindex="-1" id="birth_date" class="d-none InputText" style="direction: ltr" />
      </div>

      <div class="col-12">
        <hr />
        <h6>مشخصات صاحب سفته</h6>
      </div>
      <div class="col-md-3 col-12">
        <small>نام صاحب سفته</small>
        <input type="text" v-model="DataAxios.issuer_full_name" class="form-control" />
      </div>
      <div class="col-md-3 col-12">
        <small>کد ملی</small>
        <input type="text" @keypress="$ValidNumber($event, 10)" dir="ltr" v-model="DataAxios.issuer_national_code" class="form-control" />
      </div>
      <div class="col-md-3 col-12">
        <small>شماره حساب</small>
        <input type="text" @keypress="$ValidNumber($event, 20)" dir="ltr" v-model="DataAxios.issuer_account_number" class="form-control" />
      </div>
      <div class="col-md-3 col-12">
        <small>آدرس</small>
        <input type="text" v-model="DataAxios.issuer_address" class="form-control" />
      </div>
      <div class="col-md-3 col-12">
        <small>شماره همراه</small>
        <input type="text" @keypress="$ValidNumber($event, 11)" v-model="DataAxios.issuer_mobile_number" class="form-control" />
      </div>
      <div class="col-md-3 col-12">
        <small>کد پستی</small>
        <input type="text" v-model="DataAxios.issuer_postal_code" @keypress="$ValidNumber($event, 10)" dir="ltr" class="form-control" />
      </div>
      <!-- <div class="col-md-3 col-12">
        <small>حقیقی/حقوقی</small>
        <input type="text" v-model="DataAxios.issuer_is_legal" class="form-control" />
      </div> -->
      <!-- <div class="col-12">
        <hr />
        <h6>مشخصات دریافت کننده</h6>
      </div>
      <div class="col-md-3 col-12">
        <small>کدملی</small>
        <input type="text" v-model="DataAxios.recipient_national_code" class="form-control" />
      </div>
      <div class="col-md-9 col-12"></div> -->
      <div class="col-md-9 col-12"></div>
      <div class="col-md-3 col-12">
        <button :disabled="disableButton" @click="Submitrequest" class="btn btn-success w-100">ثبت درخواست</button>
      </div>
    </div>
    <!-- {{ DataAxios }} -->
  </div>
</template>
<script>
import Panel from '../../Tools/NetPa/Panel.vue'
import Loading from '../../Tools/NetPa/Loading.vue'
import Num2persian from 'num2persian'

export default {
  components: { Panel, Loading },
  data() {
    return {
      loadingRender: null,
      ErrorList: null,
      disableButton: false,
      DataAxios: {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BnpToken: this.$session.get('TokenNetPa'),
          LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
        },
        amount: 0,
        description: '',
        due_date: '',
        issuer_account_number: '',
        issuer_address: '',
        issuer_full_name: '',
        issuer_mobile_number: '',
        issuer_national_code: '',
        issuer_postal_code: '',
        issuer_is_legal: 'false',
        recipient_national_code: '',
      },
    }
  },
  props: ['Data'],
  methods: {
    Submitrequest() {
      this.loadingRender = true
      this.DataAxios.amount = this.DataAxios.amount + ''
      this.DataAxios.amount = Number(this.DataAxios.amount.replace(/,/g, '').replace(/\./g, ''))
      this.DataAxios.due_date = this.DataAxios.due_date.replace(/\//g, '').replace(/\./g, '')
      this.DataAxios.issuer_national_code = this.DataAxios.issuer_national_code.trim()
      var DataAxios = { method: 'POST', action: 'ElectronicSafte/Safte_Receive', arryfildValue: this.DataAxios }
      this.$PostData_netpatoken(DataAxios)
        .then((result) => {
          if (result.status == 'success') {
            this.loadingRender = false
            this.$mySweetDefaultTost('عملیات موفق', 'سفته با موفقیت ثبت شد لطفا اطلاعات روی سفته را بررسی کنید', 'success', 3000)
            this.$emit('SafteRecieved', result.data)
          } else {
            this.loadingRender = false
            this.ErrorList = result.data
          }
        })
        .finally((data) => {
          this.loadingRender = false
        })
    },
    Mab2persian() {
      var string = this.DataAxios.amount + ''
      var Mab = string.replace(/,/g, '')
      Mab = this.$b_ToPersianNumber(Mab)
      // Mab=Mab/10
      return Num2persian(Mab) + this.$cookies.get('VahedPool')
    },
  },
  created() {
    this.DataAxios.issuer_is_legal = false
    this.DataAxios.due_date = this.$GetJalaliDateTime()
  },
}
</script>
